import { useSelectedChain } from "@app/examples/ChainSelector";
import { TokenCard } from "@components/cards/TokenCard";
import { useCoins } from "@contexts/CoinsContext";
import useAlert from "@hooks/AlertHook";
import { useApi } from "@hooks/ApiHook";
import { useBaaanggg } from "@hooks/BaaangggHook";
import { useState } from "react";

export function TokensPage() {
    const alert = useAlert()
    const baaanggg = useBaaanggg()
    const { selectedChain } = useSelectedChain()
    const { refreshCoins } = useCoins()

    const [newToken, setNewToken] = useState("")
    const [search, setSearch] = useState("")
    const [isCw20, setIsCw20] = useState<boolean>()
    const { data: coins } = useApi(api => api.coin.all({ search, isCw20, chainId: selectedChain?.id }), [search, isCw20, selectedChain])

    let debounceTimer: NodeJS.Timeout;
    const onSearch = (text: string) => {
        clearTimeout(debounceTimer);
        debounceTimer = setTimeout(() => setSearch(text), 500);
    };

    const onFilterIsCw20 = (bool: boolean) => {
        if (isCw20 === bool) setIsCw20(undefined)
        else setIsCw20(bool)
    }

    const onAddToken = async () => {
        try {
            if (!newToken) throw new Error("Token address cannot be empty")
            if (!selectedChain) throw new Error("Cannot load chain")

            alert.loading("Adding new token...")
            const result = await baaanggg.coin.createToken({
                chainId: selectedChain.id,
                cw20Address: newToken
            })
            alert.hide()
            setSearch(result.cw20Address ?? "")
            alert.success("Token added successfully")
            refreshCoins()
        } catch (e) {
            if (e instanceof Error) alert.failed(e.message)
            else throw e
        }
    }

    return <main>
        <section className="relative py-24">
            <picture className="pointer-events-none absolute inset-0 -z-10 dark:hidden">
                <img src="/src/img/gradient_light.jpg" alt="gradient" className="h-full w-full" />
            </picture>
            <div className="container">
                <h1 className="py-16 text-center font-display text-4xl font-medium text-jacarta-700 dark:text-jacarta-400">
                    Available Payments
                </h1>

                <div className="lg:flex">

                    <aside className="basis-4/12 lg:pr-5">
                        <form action="search" className="relative mb-6 block">
                            <input type="search"
                                onChange={({ target }) => onSearch(target.value)}
                                className="w-full rounded-lg border border-jacarta-100 py-[0.6875rem] px-4 pl-10 text-jacarta-700 placeholder-jacarta-500 focus:ring-jacarta-500 dark:border-transparent dark:bg-gray-900 dark:text-white dark:placeholder-white"
                                placeholder="Search" />
                            <button type="submit"
                                className="absolute left-0 top-0 flex h-full w-12 items-center justify-center rounded-2xl">
                                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="24" height="24"
                                    className="h-4 w-4 fill-jacarta-500 dark:fill-white">
                                    <path fill="none" d="M0 0h24v24H0z"></path>
                                    <path
                                        d="M18.031 16.617l4.283 4.282-1.415 1.415-4.282-4.283A8.96 8.96 0 0 1 11 20c-4.968 0-9-4.032-9-9s4.032-9 9-9 9 4.032 9 9a8.96 8.96 0 0 1-1.969 5.617zm-2.006-.742A6.977 6.977 0 0 0 18 11c0-3.868-3.133-7-7-7-3.868 0-7 3.132-7 7 0 3.867 3.132 7 7 7a6.977 6.977 0 0 0 4.875-1.975l.15-.15z">
                                    </path>
                                </svg>
                            </button>
                        </form>

                        <h3 className="mb-4 font-display font-semibold text-jacarta-500 dark:text-white">Filter</h3>
                        <div className="flex flex-wrap">
                            <button
                                onClick={() => onFilterIsCw20(true)}
                                className={`group mr-2.5 mb-2.5 inline-flex items-center rounded-lg border border-jacarta-100 bg-white px-4 py-3 hover:border-transparent hover:bg-accent hover:text-white dark:border-transparent dark:text-white dark:placeholder-white dark:hover:border-transparent dark:hover:bg-jacarta-600 ${isCw20 === true ? "dark:bg-jacarta-600 dark:border-transparent" : "dark:bg-gray-900"}`}>
                                <span className="text-2xs font-medium">Token</span>
                            </button>
                            <button
                                onClick={() => onFilterIsCw20(false)}
                                className={`group mr-2.5 mb-2.5 inline-flex items-center rounded-lg border border-jacarta-100 bg-white px-4 py-3 hover:border-transparent hover:bg-accent hover:text-white dark:border-transparent dark:text-white dark:placeholder-white dark:hover:border-transparent dark:hover:bg-jacarta-600 ${isCw20 == false ? "dark:bg-jacarta-600 dark:border-transparent" : " dark:bg-gray-900"}`}>
                                <span className="text-2xs font-medium">Coin</span>
                            </button>
                        </div>

                        <h3 className="mt-3 mb-4 font-display font-semibold text-jacarta-500 dark:text-white">Add New Token</h3>


                        <div className="mx-auto mb-5 max-w-[48.125rem]">
                            <div className="mb-4">
                                <input type="text" id="item-name"
                                    value={newToken}
                                    onChange={({ target }) => setNewToken(target.value)}
                                    className="w-full rounded-lg border-jacarta-100 py-3 hover:ring-2 hover:ring-jacarta-500/10 focus:ring-jacarta-500 dark:border-transparent dark:bg-gray-900 dark:text-white dark:placeholder:text-white"
                                    placeholder="CW20 Address" />
                            </div>

                            <button
                                onClick={() => onAddToken()}
                                className="inline-block w-full rounded-full bg-jacarta-500 py-3 px-8 text-center font-semibold text-white transition-all hover:bg-jacarta-600">
                                Add
                            </button>
                        </div>
                    </aside>

                    <div className="mb-10 shrink-0 basis-8/12 space-y-5 lg:mb-0 lg:pl-10">
                        {
                            coins?.map(coin =>
                                <TokenCard key={coin.id} coin={coin} />
                            )
                        }
                    </div>


                </div>
            </div>
        </section>
    </main>
}